import { PropTypes } from 'react'

export const MetricShape = PropTypes.shape({
  name: PropTypes.string,
  value: PropTypes.number.isRequired
})
